import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Loader2, Mail } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VerifySecondaryEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const confirm = async () => {
      try {
        const res = await axios.get(`${API}/user/secondary-email/confirm/${token}`);
        setEmail(res.data.secondary_email || '');
        setStatus('success');
      } catch (e) {
        setError(e.response?.data?.detail || 'No se pudo confirmar el correo');
        setStatus('error');
      }
    };
    confirm();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0a0a12] flex items-center justify-center px-6" data-testid="verify-secondary-email-page">
      <div className="max-w-md w-full bg-white/5 border border-white/10 rounded-2xl p-8 text-center">
        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 text-purple-400 animate-spin mx-auto mb-4" />
            <p className="text-white/70">Confirmando tu correo adicional...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-16 h-16 rounded-full bg-green-500/15 flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-9 h-9 text-green-400" />
            </div>
            <h1 className="gotham-bold text-2xl text-white mb-2">¡Correo confirmado!</h1>
            <p className="text-white/60 mb-1 flex items-center justify-center gap-1.5">
              <Mail className="w-4 h-4" /> {email}
            </p>
            <p className="text-white/60 mb-6">Ya puedes iniciar sesión con este correo o con tu correo principal.</p>
            <button onClick={() => navigate('/dashboard')}
              data-testid="verify-secondary-goto-dashboard"
              className="px-6 py-3 rounded-xl bg-purple-500 hover:bg-purple-600 text-white gotham-bold w-full transition-colors">
              Ir a mi cuenta
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-16 h-16 rounded-full bg-red-500/15 flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-9 h-9 text-red-400" />
            </div>
            <h1 className="gotham-bold text-2xl text-white mb-2">No se pudo confirmar</h1>
            <p className="text-white/60 mb-6" data-testid="verify-secondary-error">{error}</p>
            <button onClick={() => navigate('/dashboard')}
              className="px-6 py-3 rounded-xl bg-white/10 hover:bg-white/15 text-white w-full transition-colors">
              Volver a mi cuenta
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifySecondaryEmail;
